import {
  CardElement,
  Elements,
  useElements,
  useStripe,
} from "@stripe/react-stripe-js";
import { loadStripe } from "@stripe/stripe-js";
import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { API, endpoints } from "../../api";
import { Loader } from "../../components";
import { useAuth } from "../../context/Auth";
import { toastType } from "../../utils/strings";
const stripePromise = loadStripe(process.env.REACT_APP_STRIPE_KEY);
const CheckoutForm = ({ actionId, setPayingUsingStripe, eventName }) => {
  const [loading, setLoading] = useState(false);
  const stripe = useStripe();
  const elements = useElements();

  const navigate = useNavigate();
  const { showToast } = useAuth();

  const handleSubmit = async (event) => {
    event.preventDefault();

    setLoading(true);
    try {
      const { error, paymentMethod } = await stripe.createPaymentMethod({
        type: "card",
        card: elements.getElement(CardElement),
      });
      if (error) {
        return setLoading(false);
      }

      if (paymentMethod) {
        const cardElement = elements.getElement(CardElement);
        let { token } = await stripe.createToken(cardElement);
        console.log(token?.id);

        var data = new FormData();
        data.append("stripeToken", token?.id);
        data.append("actionId", actionId);

        API.post({ route: endpoints.EVENT_PAY_STRIPE, data }).then(
          async (data) => {
            console.log("data => ", data);
            setLoading(false);

            if (data?.status) {
              setPayingUsingStripe(false);
              try {
                navigate(`/event-payment-success/${eventName}`);
              } catch (e) { }
            } else {
              showToast({ text: data?.message, type: toastType.ERROR });
            }
          }
        );
      } else {
        setLoading(false);
      }
    } catch (e) {
      setLoading(false);
    }
  };

  return (
    <>
      <form onSubmit={handleSubmit}>
        <div className="stripe-form pt-3" id="step2">
          <div className="form-row">
            <label htmlFor="card-element" style={{ color: " #76bbdf" }}>
              Credit or debit card
            </label>
          </div>

          <div>
            <CardElement
              className="StripeElement"
              options={{
                style: {
                  base: {
                    fontSize: "16px",
                    color: "#424770",
                    "::placeholder": {
                      color: "#aab7c4",
                    },
                  },
                  invalid: {
                    color: "#9e2146",
                  },
                },
              }}
            />
          </div>
          <div style={{ textAlign: "center", margin: 25 }}>
            <button
              className="ms-auto mt-2 mb-2 border-0 p-2 lh-20 w250 bg-mini-gradiant text-white text-center font-xssss fw-600 ls-1 rounded-xl"
              name="submintbtn2"
            >
              Pay
            </button>
          </div>
        </div>
      </form>
      {loading ? <Loader /> : null}
    </>
  );
};
const PaymentForm = ({ actionId, setPayingUsingStripe, eventName }) => (
  <div>
    <Elements stripe={stripePromise}>
      <CheckoutForm
        actionId={actionId}
        setPayingUsingStripe={setPayingUsingStripe}
        eventName={eventName}
      />
    </Elements>
  </div>
);
export default PaymentForm;
